import importerStore from '@shared/importer/importer-store';
import { FamilyService } from '@modules/family/family-service';
import familyImporterFields from '@modules/family/family-importer-fields';
import { i18n } from '@shared/i18n';

export default importerStore(
    FamilyService.import,
    familyImporterFields,
    i18n('entities.family.importer.fileName'),
    i18n('entities.family.importer.hint'),
);